import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from 'src/app/account/core/services/auth.service';
import { LiveViewService } from 'src/app/main/core/services/live-view.service';
import { IdleService } from '../../core/services/idle.service';
import { PermissionService } from '../../core/services/permission.service';
import { RedirectService } from '../../core/services/redirect.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {

  private readonly loggingOutSubject: BehaviorSubject<boolean>;
  loggingOut$: Observable<boolean>;

  hasPermissions: boolean;
  hasUserRequiredPermissionToUseApp: boolean;

  constructor(
    private readonly redirectService: RedirectService,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly permissionService: PermissionService,
    private readonly liveViewService: LiveViewService,
    private readonly idleService: IdleService,
    ) { 
      this.loggingOutSubject = new BehaviorSubject<boolean>(false);
      this.loggingOut$ = this.loggingOutSubject.asObservable();
    }

  ngOnInit() {
    this.hasPermissions = this.redirectService.redirectUrl != this.redirectService.accessDeniedUrl;
    this.hasUserRequiredPermissionToUseApp = this.permissionService.hasUserRequiredPermissionToUseApp();
  }


  back() {
    this.router.navigate(['/']);
  }

  logout() {
    this.loggingOutSubject.next(true);
    IdleService.runInitialTimer = false;
    IdleService.runFinalTimer = false;
    this.liveViewService.disconnectStreamsByTenant(this.authService.currentTenantIdValue);
    this.authService.logout();
    this.router.navigate(['/account', 'login']);
  }

}
